const curriculum = [
    {
        kbn: 1,
        menuList: [
            {
                name: "BACK",
                medthod: 'back',
                lg: "common.returnButton",
                img: "../../../static/images/icon-back-1.png",
                show: true,
            },
            {
                name: "XUAT__GHI__CHU",
                medthod: 'noteDownLoad',
                lg: "new.title12",
                img: "../../../static/images/icon-cb.png",
                show: true,
            },
            {
                name: "CAU__TRA__LOI__SAI",
                medthod: 'wrongbook',
                lg: "curriculum.errorCollection",
                img: "../../../static/images/icon-close.png",
                show: true,
            },
            {
                name: "THI__GIUA__KI",
                medthod: 'thiGiuaKi',
                lg: "curriculum.thi__giua__ki",
                img: "../../../static/images/icon-kt.png",
                show: true,
            },
            {
                name: "THI__CUOI__KI",
                medthod: 'exam',
                lg: "curriculum.exam",
                img: "../../../static/images/icon-kt.png",
                show: true,
            },
            {
                name: "THANH__TICH",
                medthod: 'scoreStatistics',
                lg: "curriculum.scoreStatistics",
                img: "../../../static/images/icon-tt.png",
                show: true,
            },
            {
                name: "BAN__CAM__KET",
                medthod: 'covenant',
                lg: "curriculum.covenant",
                img: "../../../static/images/icon-ck.png",
                show: true,
            },
            {
                name: "BANG__KHAO__SAT",
                medthod: 'questionnaire',
                lg: "curriculum.question",
                img: "../../../static/images/icon-kx.png",
                show: true,
            },
            {
                name: "TIEN__DO__KHOA__HOC",
                medthod: 'finished',
                lg: "new.title19",
                img: "../../../static/images/icon-end.png",
                show: true,
            },
            {
                name: "CHUNG__CHI",
                medthod: 'certificateExport',
                lg: "studySituationList.certificate",
                img: "../../../static/images/icon_export.png",
                show: false,
            }
        ],
    },
    {
        kbn: 2,
        menuList: [
            {
                name: "BACK",
                medthod: 'back',
                lg: "common.returnButton",
                img: "../../../static/images/icon-back-1.png",
                show: true,
            },
            {
                name: "XUAT__GHI__CHU",
                medthod: 'noteDownLoad',
                lg: "new.title12",
                img: "../../../static/images/icon-cb.png",
                show: true,
            },
            {
                name: "CAU__TRA__LOI__SAI",
                medthod: 'wrongbook',
                lg: "curriculum.errorCollection",
                img: "../../../static/images/icon-close.png",
                show: true,
            },
            {
                name: "THI__GIUA__KI",
                medthod: 'thiGiuaKi',
                lg: "curriculum.thi__giua__ki",
                img: "../../../static/images/icon-kt.png",
                show: true,
            },
            {
                name: "THI__CUOI__KI",
                medthod: 'exam',
                lg: "curriculum.exam",
                img: "../../../static/images/icon-kt.png",
                show: true,
            },
            {
                name: "THANH__TICH",
                medthod: 'scoreStatistics',
                lg: "curriculum.scoreStatistics",
                img: "../../../static/images/icon-tt.png",
                show: true,
            },
            {
                name: "BAN__CAM__KET",
                medthod: 'covenant',
                lg: "curriculum.covenant",
                img: "../../../static/images/icon-ck.png",
                show: true,
            },
            {
                name: "BANG__KHAO__SAT",
                medthod: 'questionnaire',
                lg: "curriculum.question",
                img: "../../../static/images/icon-kx.png",
                show: false,
            },
            {
                name: "TIEN__DO__KHOA__HOC",
                medthod: 'finished',
                lg: "new.title19",
                img: "../../../static/images/icon-end.png",
                show: true,
            },
            {
                name: "CHUNG__CHI",
                medthod: 'certificateExport',
                lg: "studySituationList.certificate",
                img: "../../../static/images/icon_export.png",
                show: false,
            }
        ],
    },
    {
        kbn: 3,
        menuList: [
            {
                name: "BACK",
                medthod: 'back',
                lg: "common.returnButton",
                img: "../../../static/images/icon-back-1.png",
                show: true,
            },
            {
                name: "XUAT__GHI__CHU",
                medthod: 'noteDownLoad',
                lg: "new.title12",
                img: "../../../static/images/icon-cb.png",
                show: true,
            },
            {
                name: "CAU__TRA__LOI__SAI",
                medthod: 'wrongbook',
                lg: "curriculum.errorCollection",
                img: "../../../static/images/icon-close.png",
                show: true,
            },
            {
                name: "THI__GIUA__KI",
                medthod: 'thiGiuaKi',
                lg: "curriculum.thi__giua__ki",
                img: "../../../static/images/icon-kt.png",
                show: true,
            },
            {
                name: "THI__CUOI__KI",
                medthod: 'exam',
                lg: "curriculum.exam",
                img: "../../../static/images/icon-kt.png",
                show: true,
            },
            {
                name: "THANH__TICH",
                medthod: 'scoreStatistics',
                lg: "curriculum.scoreStatistics",
                img: "../../../static/images/icon-tt.png",
                show: true,
            },
            {
                name: "BAN__CAM__KET",
                medthod: 'covenant',
                lg: "curriculum.covenant",
                img: "../../../static/images/icon-ck.png",
                show: false,
            },
            {
                name: "BANG__KHAO__SAT",
                medthod: 'questionnaire',
                lg: "curriculum.question",
                img: "../../../static/images/icon-kx.png",
                show: true,
            },
            {
                name: "TIEN__DO__KHOA__HOC",
                medthod: 'finished',
                lg: "new.title19",
                img: "../../../static/images/icon-end.png",
                show: true,
            },
            {
                name: "CHUNG__CHI",
                medthod: 'certificateExport',
                lg: "studySituationList.certificate",
                img: "../../../static/images/icon_export.png",
                show: false,
            }
        ],
    },
    {
        kbn: 4,
        menuList: [
            {
                name: "BACK",
                medthod: 'back',
                lg: "common.returnButton",
                img: "../../../static/images/icon-back-1.png",
                show: true,
            },
            {
                name: "XUAT__GHI__CHU",
                medthod: 'noteDownLoad',
                lg: "new.title12",
                img: "../../../static/images/icon-cb.png",
                show: true,
            },
            {
                name: "CAU__TRA__LOI__SAI",
                medthod: 'wrongbook',
                lg: "curriculum.errorCollection",
                img: "../../../static/images/icon-close.png",
                show: true,
            },
            {
                name: "THI__GIUA__KI",
                medthod: 'thiGiuaKi',
                lg: "curriculum.thi__giua__ki",
                img: "../../../static/images/icon-kt.png",
                show: true,
            },
            {
                name: "THI__CUOI__KI",
                medthod: 'exam',
                lg: "curriculum.exam",
                img: "../../../static/images/icon-kt.png",
                show: true,
            },
            {
                name: "THANH__TICH",
                medthod: 'scoreStatistics',
                lg: "curriculum.scoreStatistics",
                img: "../../../static/images/icon-tt.png",
                show: true,
            },
            {
                name: "BAN__CAM__KET",
                medthod: 'covenant',
                lg: "curriculum.covenant",
                img: "../../../static/images/icon-ck.png",
                show: false,
            },
            {
                name: "BANG__KHAO__SAT",
                medthod: 'questionnaire',
                lg: "curriculum.question",
                img: "../../../static/images/icon-kx.png",
                show: false,
            },
            {
                name: "TIEN__DO__KHOA__HOC",
                medthod: 'finished',
                lg: "new.title19",
                img: "../../../static/images/icon-end.png",
                show: true,
            },
            {
                name: "CHUNG__CHI",
                medthod: 'certificateExport',
                lg: "studySituationList.certificate",
                img: "../../../static/images/icon_export.png",
                show: false,
            }
        ],
    },
    {
        kbn: 5,
        menuList: [
            {
                name: "BACK",
                medthod: 'back',
                lg: "common.returnButton",
                img: "../../../static/images/icon-back-1.png",
                show: true,
            },
            {
                name: "XUAT__GHI__CHU",
                medthod: 'noteDownLoad',
                lg: "new.title12",
                img: "../../../static/images/icon-cb.png",
                show: true,
            },
            {
                name: "CAU__TRA__LOI__SAI",
                medthod: 'wrongbook',
                lg: "curriculum.errorCollection",
                img: "../../../static/images/icon-close.png",
                show: false,
            },
            {
                name: "THI__GIUA__KI",
                medthod: 'thiGiuaKi',
                lg: "curriculum.thi__giua__ki",
                img: "../../../static/images/icon-kt.png",
                show: false,
            },
            {
                name: "THI__CUOI__KI",
                medthod: 'exam',
                lg: "curriculum.exam",
                img: "../../../static/images/icon-kt.png",
                show: false,
            },
            {
                name: "THANH__TICH",
                medthod: 'scoreStatistics',
                lg: "curriculum.scoreStatistics",
                img: "../../../static/images/icon-tt.png",
                show: false,
            },
            {
                name: "BAN__CAM__KET",
                medthod: 'covenant',
                lg: "curriculum.covenant",
                img: "../../../static/images/icon-ck.png",
                show: true,
            },
            {
                name: "BANG__KHAO__SAT",
                medthod: 'questionnaire',
                lg: "curriculum.question",
                img: "../../../static/images/icon-kx.png",
                show: true,
            },
            {
                name: "TIEN__DO__KHOA__HOC",
                medthod: 'finished',
                lg: "new.title19",
                img: "../../../static/images/icon-end.png",
                show: true,
            },
            {
                name: "CHUNG__CHI",
                medthod: 'certificateExport',
                lg: "studySituationList.certificate",
                img: "../../../static/images/icon_export.png",
                show: false,
            }
        ],
    },
    {
        kbn: 6,
        menuList: [
            {
                name: "BACK",
                medthod: 'back',
                lg: "common.returnButton",
                img: "../../../static/images/icon-back-1.png",
                show: true,
            },
            {
                name: "XUAT__GHI__CHU",
                medthod: 'noteDownLoad',
                lg: "new.title12",
                img: "../../../static/images/icon-cb.png",
                show: true,
            },
            {
                name: "CAU__TRA__LOI__SAI",
                medthod: 'wrongbook',
                lg: "curriculum.errorCollection",
                img: "../../../static/images/icon-close.png",
                show: false,
            },
            {
                name: "THI__GIUA__KI",
                medthod: 'thiGiuaKi',
                lg: "curriculum.thi__giua__ki",
                img: "../../../static/images/icon-kt.png",
                show: false,
            },
            {
                name: "THI__CUOI__KI",
                medthod: 'exam',
                lg: "curriculum.exam",
                img: "../../../static/images/icon-kt.png",
                show: false,
            },
            {
                name: "THANH__TICH",
                medthod: 'scoreStatistics',
                lg: "curriculum.scoreStatistics",
                img: "../../../static/images/icon-tt.png",
                show: false,
            },
            {
                name: "BAN__CAM__KET",
                medthod: 'covenant',
                lg: "curriculum.covenant",
                img: "../../../static/images/icon-ck.png",
                show: true,
            },
            {
                name: "BANG__KHAO__SAT",
                medthod: 'questionnaire',
                lg: "curriculum.question",
                img: "../../../static/images/icon-kx.png",
                show: false,
            },
            {
                name: "TIEN__DO__KHOA__HOC",
                medthod: 'finished',
                lg: "new.title19",
                img: "../../../static/images/icon-end.png",
                show: true,
            },
            {
                name: "CHUNG__CHI",
                medthod: 'certificateExport',
                lg: "studySituationList.certificate",
                img: "../../../static/images/icon_export.png",
                show: false,
            }
        ],
    },
    {
        kbn: 7,
        menuList: [
            {
                name: "BACK",
                medthod: 'back',
                lg: "common.returnButton",
                img: "../../../static/images/icon-back-1.png",
                show: true,
            },
            {
                name: "XUAT__GHI__CHU",
                medthod: 'noteDownLoad',
                lg: "new.title12",
                img: "../../../static/images/icon-cb.png",
                show: true,
            },
            {
                name: "CAU__TRA__LOI__SAI",
                medthod: 'wrongbook',
                lg: "curriculum.errorCollection",
                img: "../../../static/images/icon-close.png",
                show: false,
            },
            {
                name: "THI__GIUA__KI",
                medthod: 'thiGiuaKi',
                lg: "curriculum.thi__giua__ki",
                img: "../../../static/images/icon-kt.png",
                show: false,
            },
            {
                name: "THI__CUOI__KI",
                medthod: 'exam',
                lg: "curriculum.exam",
                img: "../../../static/images/icon-kt.png",
                show: false,
            },
            {
                name: "THANH__TICH",
                medthod: 'scoreStatistics',
                lg: "curriculum.scoreStatistics",
                img: "../../../static/images/icon-tt.png",
                show: false,
            },
            {
                name: "BAN__CAM__KET",
                medthod: 'covenant',
                lg: "curriculum.covenant",
                img: "../../../static/images/icon-ck.png",
                show: false,
            },
            {
                name: "BANG__KHAO__SAT",
                medthod: 'questionnaire',
                lg: "curriculum.question",
                img: "../../../static/images/icon-kx.png",
                show: true,
            },
            {
                name: "TIEN__DO__KHOA__HOC",
                medthod: 'finished',
                lg: "new.title19",
                img: "../../../static/images/icon-end.png",
                show: true,
            },
            {
                name: "CHUNG__CHI",
                medthod: 'certificateExport',
                lg: "studySituationList.certificate",
                img: "../../../static/images/icon_export.png",
                show: false,
            }
        ],
    },
    {
        kbn: 8,
        menuList: [
            {
                name: "BACK",
                medthod: 'back',
                lg: "common.returnButton",
                img: "../../../static/images/icon-back-1.png",
                show: true,
            },
            {
                name: "XUAT__GHI__CHU",
                medthod: 'noteDownLoad',
                lg: "new.title12",
                img: "../../../static/images/icon-cb.png",
                show: true,
            },
            {
                name: "CAU__TRA__LOI__SAI",
                medthod: 'wrongbook',
                lg: "curriculum.errorCollection",
                img: "../../../static/images/icon-close.png",
                show: false,
            },
            {
                name: "THI__GIUA__KI",
                medthod: 'thiGiuaKi',
                lg: "curriculum.thi__giua__ki",
                img: "../../../static/images/icon-kt.png",
                show: false,
            },
            {
                name: "THI__CUOI__KI",
                medthod: 'exam',
                lg: "curriculum.exam",
                img: "../../../static/images/icon-kt.png",
                show: false,
            },
            {
                name: "THANH__TICH",
                medthod: 'scoreStatistics',
                lg: "curriculum.scoreStatistics",
                img: "../../../static/images/icon-tt.png",
                show: false,
            },
            {
                name: "BAN__CAM__KET",
                medthod: 'covenant',
                lg: "curriculum.covenant",
                img: "../../../static/images/icon-ck.png",
                show: false,
            },
            {
                name: "BANG__KHAO__SAT",
                medthod: 'questionnaire',
                lg: "curriculum.question",
                img: "../../../static/images/icon-kx.png",
                show: false,
            },
            {
                name: "TIEN__DO__KHOA__HOC",
                medthod: 'finished',
                lg: "new.title19",
                img: "../../../static/images/icon-end.png",
                show: true,
            },
            {
                name: "CHUNG__CHI",
                medthod: 'certificateExport',
                lg: "studySituationList.certificate",
                img: "../../../static/images/icon_export.png",
                show: false,
            }
        ],
    },
    {
        kbn: 9,
        menuList: [
            {
                name: "BACK",
                medthod: 'back',
                lg: "common.returnButton",
                img: "../../../static/images/icon-back-1.png",
                show: true,
            },
            {
                name: "XUAT__GHI__CHU",
                medthod: 'noteDownLoad',
                lg: "new.title12",
                img: "../../../static/images/icon-cb.png",
                show: false,
            },
            {
                name: "CAU__TRA__LOI__SAI",
                medthod: 'wrongbook',
                lg: "curriculum.errorCollection",
                img: "../../../static/images/icon-close.png",
                show: true,
            },
            {
                name: "THI__GIUA__KI",
                medthod: 'thiGiuaKi',
                lg: "curriculum.thi__giua__ki",
                img: "../../../static/images/icon-kt.png",
                show: false,
            },
            {
                name: "THI__CUOI__KI",
                medthod: 'exam',
                lg: "curriculum.exam",
                img: "../../../static/images/icon-kt.png",
                show: true,
            },
            {
                name: "THANH__TICH",
                medthod: 'scoreStatistics',
                lg: "curriculum.scoreStatistics",
                img: "../../../static/images/icon-tt.png",
                show: true,
            },
            {
                name: "BAN__CAM__KET",
                medthod: 'covenant',
                lg: "curriculum.covenant",
                img: "../../../static/images/icon-ck.png",
                show: true,
            },
            {
                name: "BANG__KHAO__SAT",
                medthod: 'questionnaire',
                lg: "curriculum.question",
                img: "../../../static/images/icon-kx.png",
                show: true,
            },
            {
                name: "TIEN__DO__KHOA__HOC",
                medthod: 'finished',
                lg: "new.title19",
                img: "../../../static/images/icon-end.png",
                show: true,
            },
            {
                name: "CHUNG__CHI",
                medthod: 'certificateExport',
                lg: "studySituationList.certificate",
                img: "../../../static/images/icon_export.png",
                show: false,
            }
        ],
    },
    {
        kbn: 10,
        menuList: [
            {
                name: "BACK",
                medthod: 'back',
                lg: "common.returnButton",
                img: "../../../static/images/icon-back-1.png",
                show: true,
            },
            {
                name: "XUAT__GHI__CHU",
                medthod: 'noteDownLoad',
                lg: "new.title12",
                img: "../../../static/images/icon-cb.png",
                show: false,
            },
            {
                name: "CAU__TRA__LOI__SAI",
                medthod: 'wrongbook',
                lg: "curriculum.errorCollection",
                img: "../../../static/images/icon-close.png",
                show: true,
            },
            {
                name: "THI__GIUA__KI",
                medthod: 'thiGiuaKi',
                lg: "curriculum.thi__giua__ki",
                img: "../../../static/images/icon-kt.png",
                show: false,
            },
            {
                name: "THI__CUOI__KI",
                medthod: 'exam',
                lg: "curriculum.exam",
                img: "../../../static/images/icon-kt.png",
                show: true,
            },
            {
                name: "THANH__TICH",
                medthod: 'scoreStatistics',
                lg: "curriculum.scoreStatistics",
                img: "../../../static/images/icon-tt.png",
                show: true,
            },
            {
                name: "BAN__CAM__KET",
                medthod: 'covenant',
                lg: "curriculum.covenant",
                img: "../../../static/images/icon-ck.png",
                show: true,
            },
            {
                name: "BANG__KHAO__SAT",
                medthod: 'questionnaire',
                lg: "curriculum.question",
                img: "../../../static/images/icon-kx.png",
                show: false,
            },
            {
                name: "TIEN__DO__KHOA__HOC",
                medthod: 'finished',
                lg: "new.title19",
                img: "../../../static/images/icon-end.png",
                show: true,
            },
            {
                name: "CHUNG__CHI",
                medthod: 'certificateExport',
                lg: "studySituationList.certificate",
                img: "../../../static/images/icon_export.png",
                show: false,
            }
        ],
    },
    {
        kbn: 11,
        menuList: [
            {
                name: "BACK",
                medthod: 'back',
                lg: "common.returnButton",
                img: "../../../static/images/icon-back-1.png",
                show: true,
            },
            {
                name: "XUAT__GHI__CHU",
                medthod: 'noteDownLoad',
                lg: "new.title12",
                img: "../../../static/images/icon-cb.png",
                show: false,
            },
            {
                name: "CAU__TRA__LOI__SAI",
                medthod: 'wrongbook',
                lg: "curriculum.errorCollection",
                img: "../../../static/images/icon-close.png",
                show: true,
            },
            {
                name: "THI__GIUA__KI",
                medthod: 'thiGiuaKi',
                lg: "curriculum.thi__giua__ki",
                img: "../../../static/images/icon-kt.png",
                show: false,
            },
            {
                name: "THI__CUOI__KI",
                medthod: 'exam',
                lg: "curriculum.exam",
                img: "../../../static/images/icon-kt.png",
                show: true,
            },
            {
                name: "THANH__TICH",
                medthod: 'scoreStatistics',
                lg: "curriculum.scoreStatistics",
                img: "../../../static/images/icon-tt.png",
                show: true,
            },
            {
                name: "BAN__CAM__KET",
                medthod: 'covenant',
                lg: "curriculum.covenant",
                img: "../../../static/images/icon-ck.png",
                show: false,
            },
            {
                name: "BANG__KHAO__SAT",
                medthod: 'questionnaire',
                lg: "curriculum.question",
                img: "../../../static/images/icon-kx.png",
                show: true,
            },
            {
                name: "TIEN__DO__KHOA__HOC",
                medthod: 'finished',
                lg: "new.title19",
                img: "../../../static/images/icon-end.png",
                show: true,
            },
            {
                name: "CHUNG__CHI",
                medthod: 'certificateExport',
                lg: "studySituationList.certificate",
                img: "../../../static/images/icon_export.png",
                show: false,
            }
        ],
    },
    {
        kbn: 12,
        menuList: [
            {
                name: "BACK",
                medthod: 'back',
                lg: "common.returnButton",
                img: "../../../static/images/icon-back-1.png",
                show: true,
            },
            {
                name: "XUAT__GHI__CHU",
                medthod: 'noteDownLoad',
                lg: "new.title12",
                img: "../../../static/images/icon-cb.png",
                show: false,
            },
            {
                name: "CAU__TRA__LOI__SAI",
                medthod: 'wrongbook',
                lg: "curriculum.errorCollection",
                img: "../../../static/images/icon-close.png",
                show: true,
            },
            {
                name: "THI__GIUA__KI",
                medthod: 'thiGiuaKi',
                lg: "curriculum.thi__giua__ki",
                img: "../../../static/images/icon-kt.png",
                show: false,
            },
            {
                name: "THI__CUOI__KI",
                medthod: 'exam',
                lg: "curriculum.exam",
                img: "../../../static/images/icon-kt.png",
                show: true,
            },
            {
                name: "THANH__TICH",
                medthod: 'scoreStatistics',
                lg: "curriculum.scoreStatistics",
                img: "../../../static/images/icon-tt.png",
                show: true,
            },
            {
                name: "BAN__CAM__KET",
                medthod: 'covenant',
                lg: "curriculum.covenant",
                img: "../../../static/images/icon-ck.png",
                show: false,
            },
            {
                name: "BANG__KHAO__SAT",
                medthod: 'questionnaire',
                lg: "curriculum.question",
                img: "../../../static/images/icon-kx.png",
                show: false,
            },
            {
                name: "TIEN__DO__KHOA__HOC",
                medthod: 'finished',
                lg: "new.title19",
                img: "../../../static/images/icon-end.png",
                show: true,
            },
            {
                name: "CHUNG__CHI",
                medthod: 'certificateExport',
                lg: "studySituationList.certificate",
                img: "../../../static/images/icon_export.png",
                show: false,
            }
        ],
    },
    {
        kbn: 13,
        menuList: [
            {
                name: "BACK",
                medthod: 'back',
                lg: "common.returnButton",
                img: "../../../static/images/icon-back-1.png",
                show: true,
            },
            {
                name: "XUAT__GHI__CHU",
                medthod: 'noteDownLoad',
                lg: "new.title12",
                img: "../../../static/images/icon-cb.png",
                show: false,
            },
            {
                name: "CAU__TRA__LOI__SAI",
                medthod: 'wrongbook',
                lg: "curriculum.errorCollection",
                img: "../../../static/images/icon-close.png",
                show: false,
            },
            {
                name: "THI__GIUA__KI",
                medthod: 'thiGiuaKi',
                lg: "curriculum.thi__giua__ki",
                img: "../../../static/images/icon-kt.png",
                show: false,
            },
            {
                name: "THI__CUOI__KI",
                medthod: 'exam',
                lg: "curriculum.exam",
                img: "../../../static/images/icon-kt.png",
                show: false,
            },
            {
                name: "THANH__TICH",
                medthod: 'scoreStatistics',
                lg: "curriculum.scoreStatistics",
                img: "../../../static/images/icon-tt.png",
                show: false,
            },
            {
                name: "BAN__CAM__KET",
                medthod: 'covenant',
                lg: "curriculum.covenant",
                img: "../../../static/images/icon-ck.png",
                show: true,
            },
            {
                name: "BANG__KHAO__SAT",
                medthod: 'questionnaire',
                lg: "curriculum.question",
                img: "../../../static/images/icon-kx.png",
                show: true,
            },
            {
                name: "TIEN__DO__KHOA__HOC",
                medthod: 'finished',
                lg: "new.title19",
                img: "../../../static/images/icon-end.png",
                show: true,
            },
            {
                name: "CHUNG__CHI",
                medthod: 'certificateExport',
                lg: "studySituationList.certificate",
                img: "../../../static/images/icon_export.png",
                show: false,
            }
        ],
    },
    {
        kbn: 14,
        menuList: [
            {
                name: "BACK",
                medthod: 'back',
                lg: "common.returnButton",
                img: "../../../static/images/icon-back-1.png",
                show: true,
            },
            {
                name: "XUAT__GHI__CHU",
                medthod: 'noteDownLoad',
                lg: "new.title12",
                img: "../../../static/images/icon-cb.png",
                show: false,
            },
            {
                name: "CAU__TRA__LOI__SAI",
                medthod: 'wrongbook',
                lg: "curriculum.errorCollection",
                img: "../../../static/images/icon-close.png",
                show: false,
            },
            {
                name: "THI__GIUA__KI",
                medthod: 'thiGiuaKi',
                lg: "curriculum.thi__giua__ki",
                img: "../../../static/images/icon-kt.png",
                show: false,
            },
            {
                name: "THI__CUOI__KI",
                medthod: 'exam',
                lg: "curriculum.exam",
                img: "../../../static/images/icon-kt.png",
                show: false,
            },
            {
                name: "THANH__TICH",
                medthod: 'scoreStatistics',
                lg: "curriculum.scoreStatistics",
                img: "../../../static/images/icon-tt.png",
                show: false,
            },
            {
                name: "BAN__CAM__KET",
                medthod: 'covenant',
                lg: "curriculum.covenant",
                img: "../../../static/images/icon-ck.png",
                show: true,
            },
            {
                name: "BANG__KHAO__SAT",
                medthod: 'questionnaire',
                lg: "curriculum.question",
                img: "../../../static/images/icon-kx.png",
                show: false,
            },
            {
                name: "TIEN__DO__KHOA__HOC",
                medthod: 'finished',
                lg: "new.title19",
                img: "../../../static/images/icon-end.png",
                show: true,
            },
            {
                name: "CHUNG__CHI",
                medthod: 'certificateExport',
                lg: "studySituationList.certificate",
                img: "../../../static/images/icon_export.png",
                show: false,
            }
        ],
    },
    {
        kbn: 15,
        menuList: [
            {
                name: "BACK",
                medthod: 'back',
                lg: "common.returnButton",
                img: "../../../static/images/icon-back-1.png",
                show: true,
            },
            {
                name: "XUAT__GHI__CHU",
                medthod: 'noteDownLoad',
                lg: "new.title12",
                img: "../../../static/images/icon-cb.png",
                show: false,
            },
            {
                name: "CAU__TRA__LOI__SAI",
                medthod: 'wrongbook',
                lg: "curriculum.errorCollection",
                img: "../../../static/images/icon-close.png",
                show: false,
            },
            {
                name: "THI__GIUA__KI",
                medthod: 'thiGiuaKi',
                lg: "curriculum.thi__giua__ki",
                img: "../../../static/images/icon-kt.png",
                show: false,
            },
            {
                name: "THI__CUOI__KI",
                medthod: 'exam',
                lg: "curriculum.exam",
                img: "../../../static/images/icon-kt.png",
                show: false,
            },
            {
                name: "THANH__TICH",
                medthod: 'scoreStatistics',
                lg: "curriculum.scoreStatistics",
                img: "../../../static/images/icon-tt.png",
                show: false,
            },
            {
                name: "BAN__CAM__KET",
                medthod: 'covenant',
                lg: "curriculum.covenant",
                img: "../../../static/images/icon-ck.png",
                show: false,
            },
            {
                name: "BANG__KHAO__SAT",
                medthod: 'questionnaire',
                lg: "curriculum.question",
                img: "../../../static/images/icon-kx.png",
                show: true,
            },
            {
                name: "TIEN__DO__KHOA__HOC",
                medthod: 'finished',
                lg: "new.title19",
                img: "../../../static/images/icon-end.png",
                show: true,
            },
            {
                name: "CHUNG__CHI",
                medthod: 'certificateExport',
                lg: "studySituationList.certificate",
                img: "../../../static/images/icon_export.png",
                show: false,
            }
        ],
    },
    {
        kbn: 16,
        menuList: [
            {
                name: "BACK",
                medthod: 'back',
                lg: "common.returnButton",
                img: "../../../static/images/icon-back-1.png",
                show: true,
            },
            {
                name: "XUAT__GHI__CHU",
                medthod: 'noteDownLoad',
                lg: "new.title12",
                img: "../../../static/images/icon-cb.png",
                show: false,
            },
            {
                name: "CAU__TRA__LOI__SAI",
                medthod: 'wrongbook',
                lg: "curriculum.errorCollection",
                img: "../../../static/images/icon-close.png",
                show: false,
            },
            {
                name: "THI__GIUA__KI",
                medthod: 'thiGiuaKi',
                lg: "curriculum.thi__giua__ki",
                img: "../../../static/images/icon-kt.png",
                show: false,
            },
            {
                name: "THI__CUOI__KI",
                medthod: 'exam',
                lg: "curriculum.exam",
                img: "../../../static/images/icon-kt.png",
                show: false,
            },
            {
                name: "THANH__TICH",
                medthod: 'scoreStatistics',
                lg: "curriculum.scoreStatistics",
                img: "../../../static/images/icon-tt.png",
                show: false,
            },
            {
                name: "BAN__CAM__KET",
                medthod: 'covenant',
                lg: "curriculum.covenant",
                img: "../../../static/images/icon-ck.png",
                show: false,
            },
            {
                name: "BANG__KHAO__SAT",
                medthod: 'questionnaire',
                lg: "curriculum.question",
                img: "../../../static/images/icon-kx.png",
                show: false,
            },
            {
                name: "TIEN__DO__KHOA__HOC",
                medthod: 'finished',
                lg: "new.title19",
                img: "../../../static/images/icon-end.png",
                show: true,
            },
            {
                name: "CHUNG__CHI",
                medthod: 'certificateExport',
                lg: "studySituationList.certificate",
                img: "../../../static/images/icon_export.png",
                show: false,
            }
        ],
    },
];

export default curriculum;



// WEBPACK FOOTER //
// ./src/assets/curriculum/data.js